import { createReducer, on } from '@ngrx/store';
import * as RentalActions from './equipment-rental.actions';
import { RentalRecord, RentalLookupPage } from '../../../../core/services/gse/equipment-rental.service';
import { EquipmentRentingClientDto } from '../../../../api/gse/models/equipment-renting-client-dto';

export interface EquipmentRentalState {
  records: RentalRecord[];
  totalRecords: number;
  loading: boolean;
  submitting: boolean;
  submitSuccess: boolean;
  error: string | null;
  // Lookup: Rental Clients
  rentalClients: RentalLookupPage<EquipmentRentingClientDto>;
  rentalClientsLoading: boolean;
  // Lookup: FBO Locations
  fboLocations: RentalLookupPage<{ id: number; name: string }>;
  fboLocationsLoading: boolean;
}

export const initialState: EquipmentRentalState = {
  records: [],
  totalRecords: 0,
  loading: false,
  submitting: false,
  submitSuccess: false,
  error: null,
  rentalClients: { data: [], totalRecords: 0 },
  rentalClientsLoading: false,
  fboLocations: { data: [], totalRecords: 0 },
  fboLocationsLoading: false,
};

export const equipmentRentalReducer = createReducer(
  initialState,
  on(RentalActions.loadRentals, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(RentalActions.loadRentalsSuccess, (state, { data, totalRecords }) => ({
    ...state,
    records: data,
    totalRecords,
    loading: false,
  })),
  on(RentalActions.loadRentalsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(RentalActions.createRental, (state) => ({
    ...state,
    submitting: true,
    submitSuccess: false,
    error: null,
  })),
  on(RentalActions.createRentalSuccess, (state) => ({
    ...state,
    submitting: false,
    submitSuccess: true,
  })),
  on(RentalActions.createRentalFailure, (state, { error }) => ({
    ...state,
    submitting: false,
    error,
  })),
  on(RentalActions.updateRental, (state) => ({
    ...state,
    submitting: true,
    submitSuccess: false,
    error: null,
  })),
  on(RentalActions.updateRentalSuccess, (state) => ({
    ...state,
    submitting: false,
    submitSuccess: true,
  })),
  on(RentalActions.updateRentalFailure, (state, { error }) => ({
    ...state,
    submitting: false,
    error,
  })),
  on(RentalActions.deleteRental, (state) => ({
    ...state,
    submitting: true,
    error: null,
  })),
  on(RentalActions.deleteRentalSuccess, (state) => ({
    ...state,
    submitting: false,
    submitSuccess: true,
  })),
  on(RentalActions.deleteRentalFailure, (state, { error }) => ({
    ...state,
    submitting: false,
    error,
  })),
  on(RentalActions.resetRentalSubmitState, (state) => ({
    ...state,
    submitSuccess: false,
    error: null,
  })),
  // Lookup: Rental Clients
  on(RentalActions.loadRentalClientsPage, (state) => ({
    ...state,
    rentalClientsLoading: true,
  })),
  on(RentalActions.loadRentalClientsPageSuccess, (state, { result }) => ({
    ...state,
    rentalClients: result,
    rentalClientsLoading: false,
  })),
  on(RentalActions.loadRentalClientsPageFailure, (state) => ({
    ...state,
    rentalClientsLoading: false,
  })),
  // Lookup: FBO Locations
  on(RentalActions.loadFboLocationsPage, (state) => ({
    ...state,
    fboLocationsLoading: true,
  })),
  on(RentalActions.loadFboLocationsPageSuccess, (state, { result }) => ({
    ...state,
    fboLocations: result,
    fboLocationsLoading: false,
  })),
  on(RentalActions.loadFboLocationsPageFailure, (state) => ({
    ...state,
    fboLocationsLoading: false,
  }))
);
